import { useSelector } from 'react-redux';

import {
  selectIsAdditionalInsurancesEnabled,
  selectAdditionalInsurancesMaxNumber,
} from '../../redux/manage-insurances/selectors/get-patient-insurances-list';

const useIsAdditionalInsurancesEnabledAndMaxNumber = () => {
  const isAdditionalInsurancesEnabled = useSelector(
    selectIsAdditionalInsurancesEnabled,
  );

  const maxAdditionalInsurancesNumber = useSelector(
    selectAdditionalInsurancesMaxNumber,
  );

  return { isAdditionalInsurancesEnabled, maxAdditionalInsurancesNumber };
};

export default useIsAdditionalInsurancesEnabledAndMaxNumber;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useIsAdditionalInsurancesEnabledAndMaxNumber.js